import { Provider, ProviderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useUpdateProviderUser = () =>
  useMutationWithLoading(
    async (params: { providerData: Provider; xTENANTID?: string }) =>
      new ProviderControllerApi(getConfigObject()).updateProvider(
        params?.providerData,
        params?.xTENANTID
      )
  );
